import React from "react";

const Java_join = () => {
  return (
    <div>
      <h1>Java join</h1>
      <p>This page provides explanations, examples, and common use-cases for Java join in Java.</p>
    </div>
  );
};

export default Java_join;
